import { Configuration, LogLevel } from "@azure/msal-browser";

import { applicationConfig, redirectConfig, tenantConfig } from "../environmentConfiguration";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: applicationConfig.clientId,
    authority: `https://login.microsoftonline.com/${tenantConfig.id}/`,
    redirectUri: redirectConfig.loginUrl,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }

        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;

          case LogLevel.Info:
            // console.debug(message);
            return;

          case LogLevel.Verbose:
            console.debug(message);
            return;

          case LogLevel.Warning:
            console.warn(message);
            return;

          default:
            return;
        }
      },
    },
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: applicationConfig.permissionScopes,
};
